import React from 'react';
import {
  Filter,
  List,
  Edit,
  Create,
  SimpleForm,
  Datagrid,
  TextField,
  TextInput,
  NumberInput,
  BooleanInput,
  EditButton,
  EmailField,
  NumberField,
  BooleanField,
  Responsive,
  SimpleList,
  downloadCSV
} from "react-admin";
import { unparse as convertToCSV } from 'papaparse/papaparse.min';

export const EntidadesFilter = props => {
  return (
    <Filter {...props}>
      <TextInput label="Nombre" source="searchnombre" autoFocus alwaysOn />
      <BooleanInput label="comprador" source="comprador" />
      <BooleanInput label="vendedor" source="vendedor" />
    </Filter>
  )
}

const exporter = data => {
    const csv = convertToCSV({
        data,
        fields: ['nombre', 'domicilio', 'telefono', 'email', 'cuit', 'vendedor', 'comprador' ],
    });
    downloadCSV(csv, 'ingreso-puerta-puerta'); // download as 'posts.csv` file
};

export const EntidadList = props => (
    <List
      {...props}
      bulkActions={false}
      filters={<EntidadesFilter />}
      exporter={exporter}
      sort={{ field: "nombre", order: "ASC" }}
    >
      <Responsive
        small={
          <SimpleList
            primaryText={record => record.nombre }
            secondaryText={record => record.email }
          />
        }
        medium={
          <Datagrid>
            <TextField source="nombre" />
            <TextField source="domicilio" />
            <TextField source="telefono" />
            <EmailField source="email" />
            <NumberField source="cuit" />
            <BooleanField source="comprador" />
            <BooleanField source="vendedor" />
            <BooleanField source="terceros" />
            <EditButton />
          </Datagrid>
        }
      />
    </List>
);

export const EntidadCreate = props => (
  <Create {...props} title="Incorporar Entidad">
    <SimpleForm redirect="/entidades">
      <TextInput label="Razon social" source="nombre" />
      <TextInput label="Domicilio" source="domicilio" />
      <TextInput label="Teléfono" source="telefono" />
      <TextInput label="Contacto" source="contacto" />
      <TextInput label="Teléfono del contacto" source="contactoTelefono" />
      <TextInput label="Email" source="email" />
      <NumberInput label="cuit" source="cuit" />
      <BooleanInput label="comprador" source="comprador" defaultValue={false} />
      <BooleanInput label="vendedor" source="vendedor" defaultValue={false} />
      <BooleanInput label="tercecros" source="terceros" defaultValue={false} />

    </SimpleForm>
  </Create>
);

export const EntidadEdit = props => (
    <Edit {...props}>
        <SimpleForm redirect="/entidades">
          <TextInput label="Razon social" source="nombre" />
          <TextInput label="Domicilio" source="domicilio" />
          <TextInput label="Teléfono" source="telefono" />
          <TextInput label="Contacto" source="contacto" />
          <TextInput label="Teléfono del contacto" source="contactoTelefono" />
          <TextInput label="Email" source="email" />
          <NumberInput label="cuit" source="cuit" />
          <BooleanInput label="comprador" source="comprador" />
          <BooleanInput label="vendedor" source="vendedor" />
          <BooleanInput label="tercecros" source="terceros" />
        </SimpleForm>
    </Edit>
);



// WEBPACK FOOTER //
// ./src/services/entidades.js